import {
    CREATE_COMPACTING_DC_DETAILS_FAILURE_DK,
    CREATE_COMPACTING_DC_DETAILS_REQUEST_DK,
    CREATE_COMPACTING_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_COMPACTING_DC_DETAILS_DK,
    DELETE_COMPACTING_DC_DETAILS_FAILURE_DK,
    DELETE_COMPACTING_DC_DETAILS_REQUEST_DK,
    DELETE_COMPACTING_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS_DK,
    FETCH_COMPACTING_DC_DETAILS_FAILURE_DK,
    FETCH_COMPACTING_DC_DETAILS_REQUEST_DK,
    FETCH_COMPACTING_DC_DETAILS_SUCCESS_DK,
    COMPACTING_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_COMPACTING_DC_DETAILS_FAILURE_DK,
    UPDATE_COMPACTING_DC_DETAILS_REQUEST_DK,
    UPDATE_COMPACTING_DC_DETAILS_SUCCESS_DK,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST_DK,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS_DK,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE_DK,
    FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST_DK,
    FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE_DK,
    FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS_DK,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST_DK,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS_DK,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE_DK,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST_DK,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS_DK,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE_DK
} from './compactingDCDetails.actionsType';

export const COMPACTING_DC_DETAILS_DK = 'compactingDcDetailsDK';

let initialState = {
    loading: false,
    compactingDCDetailsById: [],
    compactingDCDetails: [],
    previousList: [],
    grnNoByCompactingPO: [],
    compactingDCDetailsDcNo: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldFKGSM: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKBagWeight: 0,
        fldFKNoofRolls: 0,
        InwardNO: []
    },
    programList: {},
    selectedKnittingDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let compactingDCDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_COMPACTING_DC_DETAILS_REQUEST_DK:
        case FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST_DK:
        case FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST_DK:
        case FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_COMPACTING_DC_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST_DK:
        case UPDATE_COMPACTING_DC_DETAILS_REQUEST_DK:
        case DELETE_COMPACTING_DC_DETAILS_REQUEST_DK:
        case FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingDCDetails: updatePayload
            };
        case FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                programList: updatePayload
            };
        case FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                grnNoByCompactingPO: updatePayload?.Inward
            };
        case FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingDCDetailsDcNo: updatePayload?.COD
            };
        case FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingDCDetailsById: updatePayload
            };

        case CREATE_COMPACTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofRolls: 0,
                    InwardNO: []
                },
                grnNoByCompactingPO: []
            };
        case FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: updatePayload[0]
            };
        case UPDATE_COMPACTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedKnittingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofRolls: 0,
                    InwardNO: []
                }
            };
        case DELETE_COMPACTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofRolls: 0,
                    InwardNO: []
                },
                selectedKnittingDCDetails: {}
            };

        case FETCH_COMPACTING_DC_DETAILS_FAILURE_DK:
        case FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE_DK:
        case FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE_DK:
        case FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE_DK:
        case FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE_DK:
        case CREATE_COMPACTING_DC_DETAILS_FAILURE_DK:
        case UPDATE_COMPACTING_DC_DETAILS_FAILURE_DK:
        case DELETE_COMPACTING_DC_DETAILS_FAILURE_DK:
        case FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMPACTING_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case COMPACTING_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofRolls: 0,
                    InwardNO: []
                },
                selectedKnittingDCDetails: {}
            };
        default:
            return state;
    }
};
